var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef, useEffect } from 'react';
import { useVideoAnalytics } from '../creatorStorefrontPage/hooks/useVideoAnalytics';
import { HeroVideo } from './styled';
export const CreatorVideo = ({ contentId, videoRequestId, player = 'Handshake_Video_Player', src, }) => {
    const videoRef = useRef(null);
    const { attachVideoListeners, detachVideoListeners } = useVideoAnalytics({
        contentId,
        videoRequestId,
        player,
    });
    useEffect(() => {
        const video = videoRef.current;
        if (!video)
            return;
        attachVideoListeners(video);
        // Backup: attempt to play if autoplay doesn't work
        const ensureVideoPlays = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                if (video.paused) {
                    yield video.play();
                }
            }
            catch (_error) {
                // Silently handle autoplay failure - browser may require user interaction
            }
        });
        // Try to play after a short delay to ensure video is loaded
        const timeoutId = setTimeout(ensureVideoPlays, 100);
        return () => {
            clearTimeout(timeoutId);
            detachVideoListeners(video);
        };
    }, [attachVideoListeners, detachVideoListeners]);
    return (_jsx(HeroVideo, { ref: videoRef, "data-testid": "creator-video", src: src, playsInline: true, preload: "auto", muted: true, autoPlay: true, loop: true, controls: true, controlsList: "nodownload noplaybackrate", disablePictureInPicture: true }));
};
